import { TaskEvent } from '@/firebaseConfig'

const state = {
  tasks: [],
  hidden: false
}

const getters = {
  uploadingTasks: (state) => {
    return state.tasks
  },
  uploaderHidden: (state) => {
    return state.hidden
  }
}

const mutations = {
  addUploadingTask(state, value) {
    state.tasks.push(value)
    state.hidden = false
  },
  removeUploadingTaskWithName(state, taskName) {
    state.tasks = state.tasks.filter(
      (el) => el.name !== taskName
    )
  },
  setUploaderHidden(state, newVal) {
    state.hidden = newVal
  }
}

const actions = {
  hideUploader({ commit }) {
    commit('setUploaderHidden', true)
  },
  uploadFiles({ dispatch }, files) {
    files.forEach(f => {
      dispatch('uploadFile', f)
    })
  },
  uploadFile({ commit, dispatch, rootState, state }, fileData) {
    if (!fileData.file) {
      throw Error('File data must have `file` parameter defined')
    }
    if (!fileData.ref) {
      throw Error('File object must have `ref` storage reference property defined')
    }

    const file = fileData.file
    const fileRef = fileData.ref

    const metadata = {
      contentType: file.type,
      uploaderUID: rootState.user.currentUser.uid
    }
  

    commit('addUploadingTask', { name: file.name, progress: 0 })

    const uploadTask = fileRef.put(file, metadata)
    uploadTask.on(TaskEvent.STATE_CHANGED, (snapshot) => {
      const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      const info = state.tasks.find((el) => el.name === file.name)
      info.progress = progress
    }, (error) => {
      console.error(error)
      dispatch('showError', '<b>Failed to upload file</b>\n' + error.message), 
      commit('removeUploadingTaskWithName', file.name)
    }, () => {
      // upload finished successfully!
      commit('removeUploadingTaskWithName', file.name)
    })

  }
}

export default {
  state,
  getters,
  mutations,
  actions
}